import useAsyncData from "../../../../hooks/use-async-data";
import cargoCompanyService from "../../cargo-company.service";
import CargoCompanyDispatchDetails from "./cargo-company-dispatch-details";
import CargoCompanyDispatchDetailsParams from "./cargo-company-dispatch-details-params";

const useCargoCompanyDispatchDetails = () => {
  const { isLoading, setIsLoading, isError, setIsError, data, setData } =
    useAsyncData<CargoCompanyDispatchDetails | null>(null);

  const load = async (
    params: CargoCompanyDispatchDetailsParams,
    signal: AbortSignal,
  ) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const cargoCompanyDispatch = await cargoCompanyService.getDispatchDetails(
        params,
        signal,
      );

      setData(cargoCompanyDispatch);
      setIsLoading(false);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    load,
  };
};

export default useCargoCompanyDispatchDetails;
